import { RelatedTag } from '@/types';
import { fetchFromApi } from './fetchFromApi';

export const fetchRelatedTags = (term: string) => {
  return fetchFromApi<{ relatedTags: RelatedTag[] }>('relatedtags', { simple: true, term }).then(
    (data) => data.relatedTags || []
  );
};
